import type {i18n} from 'i18next';

export const getLangDirection = (i18n: i18n) =>
    'dir' in i18n ? i18n.dir(i18n.language) : 'ltr';
